"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateOfBirthInput = void 0;
const react_1 = __importStar(require("react"));
const FormFieldFeedback_1 = require("../../Forms/FormFieldFeedback/FormFieldFeedback");
const Input_1 = require("../../Forms/Input/Input");
const Text_1 = require("../../Text/Text");
const DateOfBirthInput_styles_1 = require("./DateOfBirthInput.styles");
/**
 * @deprecated Use `Ds.Form` instead
 */
const DateOfBirthInput = ({ legend, hint, dayValue, onDayChange, monthValue, onMonthChange, yearValue, onYearChange, error, inputLabels = {
    day: "Day",
    month: "Month",
    year: "Year",
}, inputIds = {
    day: "date-of-birth-day",
    month: "date-of-birth-month",
    year: "date-of-birth-year",
}, }) => {
    const handleDayChange = (event) => {
        onDayChange(event.target.value);
    };
    const handleMonthChange = (event) => {
        onMonthChange(event.target.value);
    };
    const handleYearChange = (event) => {
        onYearChange(event.target.value);
    };
    const hasError = error !== undefined;
    // For accessibility we need to have the hint and error states as descriptions of the fieldset
    // So here we add links to any of these that are present
    const fieldsDescription = (0, react_1.useMemo)(() => {
        let descriptionString = "";
        if (hint !== undefined) {
            descriptionString += "dob-field-hint-";
        }
        if (hasError) {
            descriptionString += "date-of-birth-error";
        }
        if (descriptionString.length === 0) {
            return undefined;
        }
        else {
            return descriptionString;
        }
    }, [hint, hasError]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DateOfBirthInput_styles_1.StyledBasicFieldSet, { role: "group", "aria-describedby": fieldsDescription },
            typeof legend === "string" ? (react_1.default.createElement(Text_1.Text, null, legend)) : (react_1.default.createElement(DateOfBirthInput_styles_1.StyledFullWidthLegend, null, legend)),
            hint !== undefined && (react_1.default.createElement(Text_1.Text, { props: { id: "date-of-birth-hint" }, skinny: true }, hint)),
            react_1.default.createElement(DateOfBirthInput_styles_1.StyledFieldsGroup, { id: "date-of-birth" },
                react_1.default.createElement(DateOfBirthInput_styles_1.StyledFormField, { label: inputLabels.day, labelProps: {
                        htmlFor: inputIds.day,
                    } },
                    react_1.default.createElement(Input_1.Input, { id: inputIds.day, name: inputIds.day, type: "text", autoComplete: "bday-day", inputMode: "numeric", value: dayValue, onChange: handleDayChange, hasErrors: hasError })),
                react_1.default.createElement(DateOfBirthInput_styles_1.StyledFormField, { label: inputLabels.month, labelProps: {
                        htmlFor: inputIds.month,
                    } },
                    react_1.default.createElement(Input_1.Input, { id: inputIds.month, name: inputIds.month, type: "text", autoComplete: "bday-month", inputMode: "numeric", value: monthValue, onChange: handleMonthChange, hasErrors: hasError })),
                react_1.default.createElement(DateOfBirthInput_styles_1.StyledFormField, { label: inputLabels.year, labelProps: {
                        htmlFor: inputIds.year,
                    } },
                    react_1.default.createElement(Input_1.Input, { id: inputIds.year, name: inputIds.year, type: "text", autoComplete: "bday-year", inputMode: "numeric", value: yearValue, onChange: handleYearChange, hasErrors: hasError })))),
        react_1.default.createElement(FormFieldFeedback_1.FormFieldFeedback, { id: fieldsDescription, variant: "error", text: error !== null && error !== void 0 ? error : "", "data-testid": "dob-error" })));
};
exports.DateOfBirthInput = DateOfBirthInput;
//# sourceMappingURL=DateOfBirthInput.js.map